/** Dialogue at the harbor edge: arrival, sealing the letter, 赵呈博's monologue (story §2 first paragraph). */
import type { DialogueData } from '@/core/types/contracts';
import { SPEAKER } from '../actors';
import { linear, narr, say } from './util';

export const HARBOR_DIALOGUES: DialogueData[] = [
  linear('prologue-arrival', [
    narr('南陆，绿色码头。'),
    narr('一个月的海路到了头。江子潮在码头边坐下，摊开信纸。'),
  ]),
  linear('prologue-observe-ship', [
    narr('载我们来南陆的船。水手们还在往下搬货。'),
  ]),
  linear('prologue-observe-water', [
    narr('海水一直到天边。星塘，在很远很远的北方。'),
  ]),
  linear('prologue-seal', [
    narr('江子潮把信折好，用蜡封住，放进一个玻璃瓶里。'),
  ]),
  linear('prologue-handover', [
    say(SPEAKER.jiang, '麻烦你了。这封信，带回星塘，交给琼。'),
    say(SPEAKER.returner, '放心，船一回中原就送到。'),
  ]),
  // 赵呈博's interior monologue, split around the sundial cue. The two prophecy sentences are
  // verbatim; nothing is explained.
  linear('prologue-prophecy-1', [
    narr('赵呈博远处看着江子潮封好信，交给返回的人，却思索着：'),
    narr('这样一个重情的乡下年轻人，毫无特点，甚至有点愚钝。', { emotion: 'thought' }),
    narr('是什么样的际遇使他成为预言中拯救长阳城的人呢？难道在南陆上会有什么奇遇吗？', { emotion: 'thought' }),
    narr('赵呈博来过很多次南陆，除了前几次帮助皇帝勘察地形，记录风土人情，以后的几次虽然经历过一些冒险，但从来谈不上奇遇。'),
    narr('现在他已经七十多岁了，走南闯北让他身体非常健康，须发洁白，远远看去颇有仙风。'),
    narr('然而从万千梅婆婆那里，他很早就得知了一个预言：'),
  ]),
  linear('prologue-prophecy-2', [
    narr('长阳城的富足平安，在夕阳逐渐向南移动的时候逐渐终结。', { emotion: 'prophecy' }),
    narr('而当酉时的夕阳的日晷投影指向正北方的时候，也就是整个中原遭遇灭顶之灾的时候。', { emotion: 'prophecy' }),
  ]),
  linear('prologue-prophecy-3', [
    narr('没有人知道原因，这是巫师之间的一个秘密，已经流传了好几百年。'),
    narr('这好几百年里，中原一片平静，核心城市长阳城，实现了前所未有的富足和辉煌。'),
    narr('赵呈博并非完全相信这些预言，然而，万千梅在很多关键的时候给他的提醒，让他在很多次的冒险中活了下来。'),
    narr('现在作为长阳城皇帝的勘探官，他能有今天，万千梅的点拨非常重要。'),
  ]),
];
